import {COLOR_ACTIVE, GeographyProps} from "../types";
import {Country} from "../../../../../features/countries/types";
import {Geography} from "react-simple-maps";
import theme from "../../../../../components/styles/theme/theme";
import React from "react";

const renderGeographyForRomania = (
    geo: GeographyProps,
    handleCountrySelect: (geography: any) => () => void,
    selectedCountry?: Country
) => {
    const {rsmKey, properties} = geo;

    const key = `${rsmKey}-${properties.iso3}`;

    return (
        // @ts-ignore
        <Geography
            key={key}
            stroke={theme.palette.common.white}
            strokeWidth={0.2}
            geography={geo}
            className={`${selectedCountry?.country_name}`}
            style={{
                default: {
                    fill: COLOR_ACTIVE,
                    outline: "none",
                },
                hover: {
                    fill: COLOR_ACTIVE,
                    outline: "none",
                    cursor: "pointer",
                },
                pressed: {
                    fill: COLOR_ACTIVE,
                    outline: "none",
                },
            }}
            onClick={handleCountrySelect(geo)}
        />
    );
};
export default renderGeographyForRomania;
